import { apiConfig } from '@/services/api-config';

export interface CreateTerritoryParams {
  cdCity: number;
  car: string;
  cdAgent: string;
  ownerCode: string;
  nmAgent: string;
  vlDocument: string;
  geom: string;
  name: string;
  integrationCode: string;
}

export const createTerritory = async (params: CreateTerritoryParams) => {
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);
  const tmxToken = sessionStorage.getItem('chave');
  const tokenKey = userLogged.company.stKey;

  return apiConfig
    .post(
      'api/Territory/create',
      { ...params, tokenKey },
      {
        headers: {
          Authorization: `${tmxToken}`,
        },
      },
    )
    .then((response) => response.data.objectResult)
    .catch((err) => ({ hasErros: true, message: err.message }));
};
